import { getModule } from 'vuex-module-decorators'
import SystemModule from '@/store/SystemModule'
import SystemDashboardWidget from '@/models/SystemDashboardWidget'
import GoalPickerAction from '../../filters/GoalPickerAction'

/**
 * Filter widget that hosts the GoalPickerAction in eachRightCol so the
 * action's bind offset positions it in a narrow column on the right side.
 * Option loading lives inside DashboardAction.vue's `goal-select` branch,
 * not here.
 */
export default class GoalPickerWidget extends SystemDashboardWidget {
  public type: string = 'filter'

  public key: string = 'goal-picker'

  public size: any = { lg: 12, md: 12 }

  // Initialized per-instance in the constructor so the action's companyId
  // matches the dashboard that mounted it (not shared via class default).
  public eachRightCol: any[] = []

  constructor(args: any = null) {
    super()
    this.eachRightCol = [
      new GoalPickerAction({ companyId: args?.companyId || '' }),
    ]
  }

  // Hide the picker chrome for the System (export) user; the URL still drives
  // goal selection for PDF renders.
  public show(): boolean {
    return !getModule(SystemModule).user?.isSystem
  }
}
